import React, { Component } from 'react';
import { Field } from 'formik';
import { Flex, Box } from '@rebass/grid';
import styled from 'styled-components';
import { Checkbox, Toggle } from 'freemium-ui';
import { withTranslation } from 'react-i18next';
import FieldLabel from './FieldLabel';

const FormikDateTimeProvider = ({ name, label }) => (
  <Field name={name}>
    {({ form }) => (
      <WraptFormikDateTime form={form} name={name} label={label} />
    )}
  </Field>
);

export default FormikDateTimeProvider;

class FormikDateTime extends Component {
  render() {
    const { t, name, label, form } = this.props;
    const {
      is_auto_update_status_on_start,
      is_auto_update_status_on_end,
      email_before_day_hour,
      email_before_one_hour,
      email_on_start,
      email_on_complete
    } = form.values;
    return (
      <Box mb="20px">
        <FieldLabel name={name} label={label} />
        <AutomationContainer>
          <Flex
            justifyContent="space-between"
            css={{ borderBottom: '1px solid #efefef' }}
            alignItems="center"
          >
            <CheckboxLabel my="2">
              {t('components.formikDateTime.labelScheduleStart')}
              <StyledUL>
                <li>{t('components.formikDateTime.labelStartMaintenance')}</li>
                <li>
                  {t('components.formikDateTime.labelServiceStatusStart')}
                </li>
              </StyledUL>
            </CheckboxLabel>
            <AutomationSwitch>
              <Toggle
                on={is_auto_update_status_on_start}
                handleChange={() =>
                  form.setFieldValue(
                    'is_auto_update_status_on_start',
                    !is_auto_update_status_on_start
                  )
                }
              />
            </AutomationSwitch>
          </Flex>

          <Flex
            justifyContent="space-between"
            css={{ borderBottom: '1px solid #efefef' }}
            alignItems="center"
          >
            <CheckboxLabel my="2">
              {t('components.formikDateTime.labelScheduleEnd')}
              <StyledUL>
                <li>{t('components.formikDateTime.labelEndMaintenance')}</li>
                <li>{t('components.formikDateTime.labelServiceStatusEnd')}</li>
              </StyledUL>
            </CheckboxLabel>
            <AutomationSwitch>
              <Toggle
                on={is_auto_update_status_on_end}
                handleChange={() => {
                  form.setFieldValue(
                    'is_auto_update_status_on_end',
                    !is_auto_update_status_on_end
                  );
                }}
              />
            </AutomationSwitch>
          </Flex>

          <Flex mt="10px" alignItems="center">
            <Box
              width={1 / 5}
              css={{
                color: '#87909c',
                lineHeight: 2,
                fontWeight: 500,
                fontSize: '13px'
              }}
            >
              {t('components.formikDateTime.sendRemiders')}
            </Box>
            <Box width={1 / 5}>
              <Checkbox
                name="email_before_day_hour"
                value={email_before_day_hour}
                onChange={() => {
                  form.setFieldValue(
                    'email_before_day_hour',
                    !email_before_day_hour
                  );
                }}
                checked={email_before_day_hour}
              >
                {t('components.formikDateTime.oneDayAdvance')}
              </Checkbox>
            </Box>
            <Box width={1 / 5}>
              <Checkbox
                name="email_before_one_hour"
                value={email_before_one_hour}
                onChange={() => {
                  form.setFieldValue(
                    'email_before_one_hour',
                    !email_before_one_hour
                  );
                }}
                checked={email_before_one_hour}
              >
                {t('components.formikDateTime.oneHourAdvance')}
              </Checkbox>
            </Box>
            <Box width={1 / 5}>
              <Checkbox
                name="email_on_start"
                value={email_on_start}
                onChange={() => {
                  form.setFieldValue('email_on_start', !email_on_start);
                }}
                checked={email_on_start}
              >
                {t('components.formikDateTime.labelStart')}
              </Checkbox>
            </Box>
            <Box width={1 / 5}>
              <Checkbox
                name="email_on_complete"
                value={email_on_complete}
                onChange={() => {
                  form.setFieldValue('email_on_complete', !email_on_complete);
                }}
                checked={email_on_complete}
              >
                {t('components.formikDateTime.onCompletion')}
              </Checkbox>
            </Box>
          </Flex>
        </AutomationContainer>
      </Box>
    );
  }
}

const WraptFormikDateTime = withTranslation()(FormikDateTime);

const AutomationContainer = styled.div`
  border: solid 1px #e4e2e2;
  padding: 10px 12px;
  border-radius: 3px;
  margin-top: 4px;
`;

const CheckboxLabel = styled(Box)`
  font-size: 13px;
  letter-spacing: 0.2px;
  color: #12354c;
`;
const AutomationSwitch = styled(Box)`
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.2px;
  color: #12354c;
`;

const StyledUL = styled.ul`
  padding-left: 20px;
  color: #878f9c;
`;
